(() => {
  const MOBILE_MAX = 989;
  const COMPACT_AT = 72;
  let ticking = false;
  const updateHeaderState = () => {
    ticking = false;
    const isMobile = window.innerWidth <= MOBILE_MAX;
    const isPastThreshold = window.scrollY > COMPACT_AT;
    document.querySelectorAll('.lamseti-mega-header.is-sticky').forEach((header) => {
      const menuOpen = Boolean(header.querySelector('.kh-mobile-menu[open]'));
      header.classList.toggle('is-mobile-compact', isMobile && isPastThreshold && !menuOpen);
    });
  };
  const requestUpdate = () => { if (ticking) return; ticking = true; window.requestAnimationFrame(updateHeaderState); };
  const bindMenuState = (root = document) => {
    root.querySelectorAll?.('.lamseti-mega-header .kh-mobile-menu').forEach((menu) => {
      if (menu.dataset.lamsetiPolishBound === 'true') return;
      menu.dataset.lamsetiPolishBound = 'true';
      menu.addEventListener('toggle', requestUpdate);
    });
  };
  const init = (root = document) => { bindMenuState(root); requestUpdate(); };
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
